import { Component, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'phone-stats-module',
  styleUrl: 'phone-stats-module.scss',
  shadow: true,
})
export class ModulePhoneStats {
  @Prop() readonly data: { columns: number[]; timeline: string[] };
  @Prop() readonly color_bg: string = '#0098FF';

  private lang = wcShared?.store?.utils.getLang();
  private periodValidity: boolean[] = [];
  private columnsHTML: HTMLDivElement;

  componentWillLoad() {
    this.calculPeriod();
  }
  componentDidLoad() {
    this.columnsHTML?.querySelectorAll('.phone-stats-column').forEach((column: HTMLDivElement) => {
      setTimeout(
        () => {
          column.classList.add(`height-${column.dataset.value}`);
        },
        Number(column.dataset.value) * 5,
      );
    });
  }

  // private hex(c) {
  //   const s = '0123456789abcdef';
  //   let i = parseInt(c);
  //   if (i == 0 || isNaN(c)) return '00';
  //   i = Math.round(Math.min(Math.max(0, i), 255));
  //   return s.charAt((i - (i % 16)) / 16) + s.charAt(i % 16);
  // }

  /* Convert an RGB triplet to a hex string */
  // private convertToHex(rgb) {
  //   return this.hex(rgb[0]) + this.hex(rgb[1]) + this.hex(rgb[2]);
  // }

  /* Remove '#' in color hex string */
  // private trim(s) {
  //   return s.charAt(0) == '#' ? s.substring(1, 7) : s;
  // }

  /* Convert a hex string to an RGB triplet */
  // private convertToRGB(hex) {
  //   const color = [];
  //   color[0] = parseInt(this.trim(hex).substring(0, 2), 16);
  //   color[1] = parseInt(this.trim(hex).substring(2, 4), 16);
  //   color[2] = parseInt(this.trim(hex).substring(4, 6), 16);
  //   return color;
  // }

  // private generateColor(colorStart, colorEnd, colorCount) {
  //   // The beginning of your gradient
  //   const start = this.convertToRGB(colorStart);
  //
  //   // The end of your gradient
  //   const end = this.convertToRGB(colorEnd);
  //
  //   // The number of colors to compute
  //   const len = colorCount;
  //
  //   //Alpha blending amount
  //   let alpha = 0.0;
  //
  //   const result = [];
  //
  //   for (let i = 0; i < len; i++) {
  //     const c = [];
  //     alpha += 1.0 / len;
  //
  //     c[0] = start[0] * alpha + (1 - alpha) * end[0];
  //     c[1] = start[1] * alpha + (1 - alpha) * end[1];
  //     c[2] = start[2] * alpha + (1 - alpha) * end[2];
  //
  //     result?.push('#' + this.convertToHex(c));
  //   }
  //
  //   return result.reverse();
  // }

  private calculPeriod() {
    const currentDate = new Date();
    let start = 0;
    this.data.timeline.forEach((date, index) => {
      let dateRaw;
      if (index === 0) {
        dateRaw = parseInt(date.split(':')[0], 10);
        start = dateRaw;
      } else {
        dateRaw = start + index;
      }
      const validity = dateRaw - 1 >= currentDate.getUTCHours();
      this.periodValidity?.push(validity);
    });
  }

  private formatData(value: number) {
    if (value <= 25) {
      return {
        label: wcShared?.translate("Temps d'attente faible"),
        color: this.color_bg,
        opacity: 0.25,
      };
    } else if (value <= 50) {
      return {
        label: wcShared?.translate("Temps d'attente moyen"),
        color: this.color_bg,
        opacity: 0.5,
      };
    } else if (value <= 75) {
      return {
        label: wcShared?.translate("Temps d'attente eleve"),
        color: this.color_bg,
        opacity: 0.75,
      };
    } else {
      return {
        label: wcShared?.translate("Temps d'attente tres eleve"),
        color: this.color_bg,
        opacity: 1,
      };
    }
  }

  render() {
    return (
      <Host>
        <div class="phone-stats">
          <div
            class="phone-stats-columns"
            ref={(el) => (this.columnsHTML = el as HTMLInputElement)}
          >
            {this.data.columns?.map((value, index) => {
              return (
                <div
                  data-value={value}
                  class="phone-stats-column tooltip"
                  style={{
                    width: 100 / this.data.columns.length + '%',
                    transition: ((value / 100) * 2).toString() + 's',
                  }}
                >
                  <span class="tooltiptext">{this.formatData(value).label}</span>
                  <div
                    class="phone-stats-column--bg"
                    style={{
                      background: this.periodValidity[index]
                        ? this.formatData(value).color
                        : wcShared?.store?.theme === 'light'
                          ? '#333333'
                          : '#979BA4',
                      opacity: this.periodValidity[index]
                        ? this.formatData(value).opacity.toString()
                        : '0.2',
                    }}
                  ></div>
                </div>
              );
            })}
          </div>
          <div class="phone-stats-timeline">
            {this.data.timeline?.map((time) => {
              return (
                <div
                  class="phone-stats-timeline__time"
                  style={{ width: `calc(100% / ${this.data.columns.length})` }}
                >
                  {wcShared?.store?.utils?.pmToAm(time, this.lang, true)}
                </div>
              );
            })}
          </div>
        </div>
      </Host>
    );
  }
}
